Q     = require('q')
axios = require('axios')
_     = require('underscore')

module.exports = require('frontend/components/abstract').extend
  template: require('./index.pug')

  components:
    'prevented-form':     require('../prevented_form')
    'loading-indicator':  require('../loading_indicator')
    'form-input':         require('../form/input')
    'form-textarea':      require('../form/textarea')
    'form-select':        require('../form/select')
    'form-checkbox':      require('../form/checkbox')

  data: ->
    done:       false
    formData:   {}
    errors:     {}

  computed:

    isFinancingSelf: ->
      @formData.financing == 'self'

    isFinancingExternal: ->
      @formData.financing == 'external'

    isFinancingNone: ->
      @formData.financing == 'none'

    isFinancingSelected: ->
      _.contains(['self', 'external', 'none'], @formData.financing)

    termsCheckboxContent: ->
      @.$t('school_registration_form.terms_accept', { url: @.$store.state.settings.urls.terms_url })

  methods:

    onClickSubmit: ->
      @.$refs.form.submit()

    onClickFinancing: (option) ->
      @.$set @formData, 'financing', option

    resetDataToDefaults: ->
      @.$set @, 'formData', {
        salutation:     null
        firstname:      null
        lastname:       null
        phone:          null
        mail:           null
        school_name:    null
        school_phone:   null
        school_mail:    null
        school_website: null
        school_country: null
        school_city:    null
        school_address: null
        participating_classes:  null
        participating_pupils:   null
        financing:                            null
        financing_self_name:                  null
        financing_self_email:                 null
        financing_self_address:               null
        financing_external_sponsor_name:      null
        financing_external_sponsor_address:   null
        financing_external_sponsor_country:   null
        financing_external_sponsor_website:   null
        financing_external_contact_salutation:null
        financing_external_sponsor_firstname: null
        financing_external_sponsor_lastname:  null
        financing_external_sponsor_phone:     null
        financing_external_sponsor_fax:       null
        financing_external_sponsor_mail:      null
      }
      @.$set @, 'errors', {}

    showLoadingIndicator: ->
      @.$refs.loadingIndicator.show()

    hideLoadingIndicator: ->
      @.$refs.loadingIndicator.hide()

    getCsrfToken: ->
      document.querySelector('meta[name="csrf-token"]').getAttribute('content')

    getErrorMessage: (attrName) ->
      return null unless _.any(@errors[attrName] || [])
      _.first(@errors[attrName])

    submit: ->
      gRecaptchaResponse = @.$refs.recaptcha.getRecaptchaResponse()
      return unless _.isString(gRecaptchaResponse) && _.size(gRecaptchaResponse) > 0

      if @formData.terms_accepted != true
        @.$set @errors, 'terms_accepted', ['AGB müssen akzeptiert werden.']
        return
      else
        @.$set @errors, 'terms_accepted', null

      @showLoadingIndicator()

      signInData = {
        method:   'post'
        url:      '/api/school_registrations'
        data:     { data: @formData, g_recaptcha_response: gRecaptchaResponse }
        headers:  { 'X-CSRF-Token': @getCsrfToken() }
      }

      errorFunc = (error) =>
        window.error = error
        if error.response?.data?
          @.$set @, 'error', error.response.data.error
        else
          @.$set @, 'error', 'Fehler bei der Registrierung'

        @hideLoadingIndicator()

      axios(signInData)
      .then (response) =>
        data = response.data?.data || {}
        @.$set @, 'errors', data.errors || {}
        @.$set @, 'done', true unless _.size(@errors) > 0

        @hideLoadingIndicator()
      .catch(errorFunc)

  created: ->
    @resetDataToDefaults()


// WEBPACK FOOTER //
// ./assets/js/frontend/components/contact_form_registration/index.coffee